import { 
    SELECT_COLOR, 
    SELECTED_TYPE, 
    SELECTED_ALL_TYPE, 
    SELECT_APPLICATION,
    SELECT_MATERIAL,
    SELECT_FINISH,
    SET_PRICE,
    CLEAR_FILTERS,
    SET_TO_COMPARE_MATERIAL,
    REMOVE_COMPARABLE_MATERIAL,
    SET_MATERIAL_LIST,
    SET_SCROLL_PAGE_POINT,
    RESET_SCROLL_POINT,
    SET_INITIAL_FILTER,
    REFETCH_MATERIAL,
    SET_ITEM_AS_SELECTED,
    SET_ITEM_AS_UNSELECTED,
    REMOVE_ALL_MATERIALS_FROM_COMPARATOR,
} from './types'

import Granito from '../assets/img/materials_types/granito.png'
import Marmore from '../assets/img/materials_types/marmore.png'
import Marmore_Composto from '../assets/img/materials_types/marmore_composto.png'
import Onix from '../assets/img/materials_types/onix.png'
import Travertino from '../assets/img/materials_types/travertino.png'
import Quartzo from '../assets/img/materials_types/quartzo.png'
import Quartzito from '../assets/img/materials_types/quartzito.png'
import Ultra_Compacto from '../assets/img/materials_types/ultra_compacto.png'

import GranitoDesk from '../assets/img/materials_types_desktop/granito.png'
import MarmoreCompostoDesk from '../assets/img/materials_types_desktop/marmore_composto.png'
import MarmoreDesk from '../assets/img/materials_types_desktop/marmore.png'
import OnixDesk from '../assets/img/materials_types_desktop/onix.png'
import QuartzitoDesk from '../assets/img/materials_types_desktop/quartzito.png'
import QuartzoDesk from '../assets/img/materials_types_desktop/quartzo.png'
import TravertinoDesk from '../assets/img/materials_types_desktop/travertino.png'
import UltraCompactoDesk from '../assets/img/materials_types_desktop/ultra_compacto.png'

const initial = {
    applications: [{
        name: 'área externa',
        selected: false,
        key: 'external_coating'   
    },{
        name: 'área interna',
        selected: false,
        key: 'inner_wall'   
    },{
        name: 'bancada cozinha',
        selected: false,
        key: 'kitchen_bench'   
    },{
        name: 'bancada banheiro',
        selected: false,
        key: 'restroom_stand'
    },{
        name: 'área de serviço',
        selected: false,
        key: 'service_area'   
    },{
        name: 'cozinha',
        selected: false,
        key: 'kitchen'   
    },{
        name: 'churrasqueira',
        selected: false,
        key: 'barbecue_grill'   
    },{
        name: 'lareira',
        selected: false,
        key: 'fireplace'   
    },{
        name: 'banheiro',
        selected: false,
        key: 'restroom'   
    },{
        name: 'escada',
        selected: false,
        key: 'staircase'   
    },{
        name: 'lavabo',
        selected: false,
        key: 'toilet'   
    },{
        name: 'soleira e baguete',
        selected: false,
        key: 'threshold_baguette'   
    },{
        name: 'piso e revestimento',
        selected: false,
        key: 'floor_cladding'   
    }],
    types: [{
        name: 'granito',
        selected: false,
        image: Granito,
        image_desktop: GranitoDesk
    },{ 
        name: 'mármore',
        selected: false,
        image: Marmore,
        image_desktop: MarmoreDesk
    },{ 
        name: 'mármore composto',
        selected: false,
        image: Marmore_Composto,
        image_desktop: MarmoreCompostoDesk
    },{ 
        name: 'ônix',
        selected: false,
        image: Onix,
        image_desktop: OnixDesk
    },{
        name: 'travertino',
        selected: false,
        image: Travertino,
        image_desktop: TravertinoDesk
    },{
        name: 'quartzo',
        selected: false,
        image: Quartzo,
        image_desktop: QuartzoDesk
    },{ 
        name: 'quartzito',
        selected: false,
        image: Quartzito,
        image_desktop: QuartzitoDesk
    },{ 
        name: 'ultra compacto',
        selected: false,
        image: Ultra_Compacto,
        image_desktop: UltraCompactoDesk
    }],
    colors: [{
        name: 'amarelo',
        selected: false
      },{
        name: 'azul',
        selected: false  
      },{
        name: 'bege',
        selected: false
      },{
        name: 'branco',
        selected: false
      },{
        name: 'rosa',
        selected: false
      },{
        name: 'verde',
        selected: false
      },{
        name: 'vermelho',
        selected: false 
      },{
        name: 'cinza',
        selected: false 
      },{
        name: 'marrom',
        selected: false
      },{
        name: 'preto',
        selected: false   
      },{
        name: 'laranja',
        selected: false   
      },{
        name: 'castanho',
        selected: false
      },{
        name: 'dourado',
        selected: false  
      },{
        name: 'roxo',
        selected: false
      },{
        name: 'creme',
        selected: false  
      },{
        name: 'translúcido',
        selected: false
      }],
    finishing: [{
        name: 'bruto',
        selected: false,
        key: 'gross'
    },
    {
        name: 'polido',
        selected: false,
        key: 'polished'   
    },{
        name: 'levigado',
        selected: false,
        key: 'levitated'   
    },{
        name: 'escovado',
        selected: false,
        key: 'brushed'   
    },{
        name: 'flameado',
        selected: false,
        key: 'flamed'   
    },{
        name: 'leathered',
        selected: false,
        key: 'leathered'
    },{
        name: 'jateado',
        selected: false,
        key: 'jateado'
    },{
        name: 'acetinado',
        selected: false,
        key: 'acetinado'
    }],
    material: [{
        name: 'natural',
        selected: false,
        key: 'natural'
    }, {
        name: 'industrializado',
        selected: false,
        key: 'industrialized'
    }]  
}

const materialState = {
    price: 0,
    filters: initial,
    comparator: [],
    material_list: [],
    scroll_page_point: 0,
    initial_filter: [],
    refetch: false,
    selected_materials_names: []
}

const selectAll = materials => {

    const isAllSelected = materials.every(item => item.selected);
    let update = isAllSelected ? false : true;

    const updated = materials.map(item => {
        item.selected = update
        return item
    })

    return updated
}

const select = (items, type) => {
    const updated = items.map(item => {
        if (item.name === type) {
            item.selected = !item.selected
        }
        return item
    })

    return  updated
}

const setMaterialToCompare = (item, compare) => {
    let copy = [ ...compare ]

    const found = copy.find(material => item._id === material._id)

    if (found) return copy

    if (copy.length >= 3) {
        copy.shift()
        copy.push(item)
        return copy
    }
    
    copy.push(item)

    return copy
}

const removeMaterialCompare = (item, compare) => {
    let copy = [ ...compare ]
    const updated = copy.filter(material => item._id !== material._id)
    return updated
}

const setAllToFalse = (items, initial) => {

    let updatedFilters = {}
    const copy = { ...items };
    const keys = Object.keys(copy)

    for (let i = 0; i < keys.length; i++ ) {
        updatedFilters[keys[i]] = items[keys[i]].map( item => {
            item.selected = false
            return item
        })
    }

    updatedFilters.types = updatedFilters.types.map(item => {
        return {
            ...item,
            selected: false
        }
    })

    return updatedFilters
}

const updateMaterialList = (item, list, propertie) => {

    let newList = [ ...list ]

    newList = newList.map( cur => {

        let copyCur = { ...cur }

        if (copyCur.name === item.type) {

            copyCur.materials = copyCur.materials.map( mat => {

                let newMat = { ...mat }
                
                if (newMat.name === item.name) {
                    newMat.selected_to_use = propertie
                }

                return newMat
            })

            return copyCur

        }

        return copyCur

    })

    return newList

}

const materialReducer = (state, actions) => {
    const { type, payload } = actions

    switch (type) {
        case SELECT_APPLICATION: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    applications: select(state.filters.applications, payload)
                }
            }
        }
        case SELECT_COLOR: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    colors: select(state.filters.colors, payload)
                }
            }
        }
        case SELECTED_TYPE: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    types: select(state.filters.types, payload)
                }
            }
        }
        case SELECTED_ALL_TYPE: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    types: selectAll(state.filters.types)
                }
            }
        }
        case SELECT_MATERIAL: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    material: select(state.filters.material, payload)
                }
            }
        }
        case SELECT_FINISH: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    finishing: select(state.filters.finishing, payload) 
                }
            }
        }
        case SET_PRICE: {
            return {
                ...state,
                price: Number(payload)
            }
        }
        case CLEAR_FILTERS: {
            return {
                ...state,
                price: 0,
                filters: setAllToFalse(state.filters, state.initial_filter)
            }
        }
        case SET_TO_COMPARE_MATERIAL: {
            return {
                ...state,
                comparator: setMaterialToCompare(payload, state.comparator)
            }
        }
        case REMOVE_COMPARABLE_MATERIAL: {
            return {
                ...state,
                comparator: removeMaterialCompare(payload, state.comparator)
            }
        }
        case REMOVE_ALL_MATERIALS_FROM_COMPARATOR: {
            return {
                ...state,
                comparator: []
            }
        }
        case SET_MATERIAL_LIST: {
            return {
                ...state,
                material_list: payload
            }
        }
        case SET_SCROLL_PAGE_POINT: {
            return {
                ...state,
                scroll_page_point: payload
            }
        }
        case RESET_SCROLL_POINT: {
            return {
                ...state,
                scroll_page_point: 0
            }
        }
        case SET_INITIAL_FILTER: {
            const copy = [...payload]
            return {
                ...state,
                initial_filter: copy.filter(item => item.selected)
            }
        }
        case REFETCH_MATERIAL: {
            return {
                ...state,
                refetch: payload
            }
        }
        case SET_ITEM_AS_SELECTED: {
            return {
                ...state,
                material_list: updateMaterialList(payload, state.material_list, true)
            }
        }
        case SET_ITEM_AS_UNSELECTED: {
            return {
                ...state,
                material_list: updateMaterialList(payload, state.material_list, false)
            }
        }
        default: {
          return state
        }
    }
}

export { materialReducer as default, materialState }